import { gql } from "@apollo/client";

export const Fleet = gql`
query da_fleets {
  aatmsv4_fleets(where: {active: {_eq: true}}, order_by: {aircraft: asc}) {
    clientsid
    clientname
    fleetsid
    aircraft
    active
    _crew
    _ground
    _simulator
    _aircraft
    _manager
    _optimiser
  }
}`;


export const Fleeet = gql`
query da_fleets(
  $active: Boolean 
  ) {
  aatmsv4_fleets(where: {active: {_eq: $active}}, order_by: {aircraft: asc}) {
    clientsid
    clientname
    fleetsid
    aircraft
    active
    _crew
    _ground
    _simulator
    _aircraft
    _manager
    _optimiser
  }
}`;

export const clients = gql`
query Da_Clients {
  aatmsv4_clients{
    clientsid
    clientname
  }
}
`
export const update_aatms_fleets = gql`
mutation da_fleets_edit(
  $aircraft: String
  $clientid: uuid
  $id: uuid
  $clientname: String
  $active: Boolean
) {
  update_aatmsv4_fleets(where: {fleetsid: {_eq: $id}}, _set: {aircraft: $aircraft, active: $active, _crew: true, _ground: true, _simulator: true, _aircraft: true, _manager: true, _optimiser: true, clientsid: $clientid, clientname: $clientname}) {
    returning {
      clientsid
      clientname
      fleetsid
      aircraft
      active
      _crew
      _ground
      _simulator
      _aircraft
      _manager
      _optimiser
    }
  }
}
`


export const delete_aatms_fleets = gql`
mutation da_fleets_delete(
  $id: uuid
  $active: Boolean
) {
  update_aatmsv4_fleets(where: {fleetsid: {_eq: $id}}, _set: {active: $active, _crew: false, _ground: false, _simulator: false, _aircraft: false, _manager: false, _optimiser: false}) {
    returning {
      clientsid
      clientname
      fleetsid
      aircraft
      active
      _crew
      _ground
      _simulator
      _aircraft
      _manager
      _optimiser
    }
  }
}
`

export const insert_aatms_fleets = gql`
mutation da_fleets_add(
  $clientid: uuid!
  $clientname: String!
  $aircraft:String!
  ) {
  insert_aatmsv4_fleets(objects: {
    clientname: $clientname,
    clientsid: $clientid,
    aircraft: $aircraft, active: true, _crew: true, _ground: true, _simulator: true, _aircraft: true, _manager: true, _optimiser: true}) {
    returning {
      clientsid
      clientname
      fleetsid
      aircraft
      active
      _ground
      _simulator
      _aircraft
      _crew
      _manager
      _optimiser
    }
  }
}
`